import { Box, Checkbox, Container, FormControlLabel, Grid, Modal, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { Component } from 'react'
import Constantes from '../php/Constantes';

const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

class SalidaEntreHorario extends Component {
    constructor(props){
        super(props);
        this.state = {
            errores: null,
            notificaciones: null,

            consultaSalidas: {
                numeroFuncionario: '',
                fecha: '',
            },

            consulta: false,
            modalBorrar: false,
            modalEditar: false,

            marBorrar: {
                idMovimiento: '',
                numeroFuncionario: '',
                nombreFuncionario: '',
                desde: '',
                entradaSEH: '',
                salidaSEH: '',
            },

            datosConsulta: [],
        }

        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejoEnvioNumeroFuncionario = this.manejoEnvioNumeroFuncionario.bind(this);
        this.manejarBorrar = this.manejarBorrar.bind(this);
        this.manejarEdicion = this.manejarEdicion.bind(this);
        this.manejarAtras = this.manejarAtras.bind(this);
        this.manejarEnvioBaja = this.manejarEnvioBaja.bind(this);
        this.cerrarModal = this.cerrarModal.bind(this);
        this.manejarCambioEditar = this.manejarCambioEditar.bind(this);
        this.manejarEnvioModificar = this.manejarEnvioModificar.bind(this);
    }
    async componentDidMount(){}
    render (){
        return (
            <>
                <Container>
                    <form className='formulario'  onSubmit={this.manejoEnvioNumeroFuncionario}>
                        <h3>Salidas Entre Horario</h3>
                        {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                        {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                        <Box sx={{ flexGrow: 1}}>
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={2.1}>
                                    <Item>Número de Funcionario <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p></Item>
                                </Grid>
                                <Grid item xs={3}>
                                    <Item><input style={{border: "2px solid #D6EAF8", width: "100%"}} id='numeroFuncionario' value={this.state.consultaSalidas.numeroFuncionario} onChange={this.manejarCambiosDatos} type="text" /></Item>
                                </Grid>
                                <Grid item xs={2.1}>
                                    <Item>Desde</Item>
                                </Grid>
                                <Grid item xs={3}>
                                    <Item><input min={'1000-01-01'} max={'9999-12-31'} style={{border: "2px solid #D6EAF8", width: "100%"}} id='fecha' value={this.state.consultaSalidas.fecha} onChange={this.manejarCambiosDatos} type="date" /></Item>
                                </Grid>
                                <Grid item xs={1}>
                                    <button className="btn btn-outline-primary mx-2" type='submit'>Buscar</button>
                                </Grid>
                            </Grid>
                        </Box>
                    </form>
                </Container>
                {this.state.consulta
                ?
                    <Container>
                        {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                        {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                        <TableContainer>
                            <Table sx={{minWidth: 700}}>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell align="center" colSpan={10}>Marcas Manual - Funcionario: {this.state.datosConsulta[0].numeroFuncionario} - {this.state.datosConsulta[0].nombreFuncionario}</StyledTableCell>
                                    </TableRow>
                                    <TableRow>
                                        <StyledTableCell>Fecha</StyledTableCell>
                                        <StyledTableCell>Marca 1</StyledTableCell>
                                        <StyledTableCell>Marca 2</StyledTableCell>
                                        <StyledTableCell></StyledTableCell>
                                        <StyledTableCell></StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.datosConsulta.map((datosOmi) => (
                                        <StyledTableRow key={datosOmi.idMovimiento}>
                                            <StyledTableCell>{datosOmi.desde}</StyledTableCell>
                                            <StyledTableCell>{datosOmi.salidaSEH}</StyledTableCell>
                                            <StyledTableCell>{datosOmi.entradaSEH}</StyledTableCell>
                                            <StyledTableCell><button className="btn btn-outline-danger mx-2" onClick={() => this.manejarEdicion(datosOmi)}>Editar</button></StyledTableCell>
                                            <StyledTableCell><button className="btn btn-outline-dark mx-2" type='button' onClick={() => this.manejarBorrar(datosOmi)}>Borrar</button></StyledTableCell>
                                        </StyledTableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Container>
                :
                    null
                }
                <br/>
                <br/>
                {this.state.consulta
                ?
                    <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtras}>Volver</button>
                :
                    null
                }
                <br/>
                <br/>
                <Modal open={this.state.modalBorrar}>
                    <form className='formulario1'>
                        <Box sx={styleModal}>
                            <h3 style={{textAlign:'center'}}>¿Confirmar Baja Salida Entre Horario?</h3>
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={2}>

                                </Grid>
                                <Grid item xs={4}>
                                    <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioBaja}>Confirmar</button>
                                </Grid>
                                <Grid item xs={4}>
                                    <button className="btn btn-outline-danger mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.cerrarModal}>Cancelar</button>
                                </Grid>
                            </Grid>
                        </Box>
                    </form>
                </Modal>
                <Modal open={this.state.modalEditar}>
                    <form className='formulario1'>
                        <Box sx={styleModal} >
                            <h3 style={{textAlign:'center'}}>Editar Salida Entre Horario</h3>
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={2.5}>
                                <   Item>Número</Item>
                                </Grid>
                                <Grid item xs={2}>
                                    <Item>{this.state.marBorrar.numeroFuncionario}</Item>
                                </Grid>
                                <Grid item xs={0.5}>

                                </Grid>
                                <Grid item xs={2.5}>
                                    <Item>Nombre: </Item>
                                </Grid>
                                <Grid item xs={4.5}>
                                    <Item>{this.state.marBorrar.nombreFuncionario}</Item>
                                </Grid>
                                <Grid item xs={2.5}>
                                    <Item>Marca 1: </Item>
                                </Grid>
                                <Grid item xs={0.1}>

                                </Grid>
                                <Grid item xs={4}>
                                    <Item><input style={{border: "2px solid #D6EAF8", width: "100%"}} id='salidaSEH' value={this.state.marBorrar.salidaSEH} onChange={this.manejarCambioEditar} type="time" /></Item>
                                </Grid>
                                <Grid item xs={5}>

                                </Grid>
                                <Grid item xs={2.5}>
                                    <Item>Marca 2: </Item>
                                </Grid>
                                <Grid item xs={0.1}>

                                </Grid>
                                <Grid item xs={4}>
                                    <Item><input style={{border: "2px solid #D6EAF8", width: "100%"}} id='entradaSEH' value={this.state.marBorrar.entradaSEH} onChange={this.manejarCambioEditar} type="time" /></Item>
                                </Grid>
                                <Grid item xs={5}>

                                </Grid>
                                <Grid item xs={2}>

                                </Grid>
                                <Grid item xs={4}>
                                    <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioModificar}>Confirmar</button>
                                </Grid>
                                <Grid item xs={4}>
                                    <button className="btn btn-outline-danger mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.cerrarModal}>Cancelar</button>
                                </Grid>
                            </Grid>
                        </Box>
                    </form>
                </Modal>
            </>
        )
    }

    manejarCambiosDatos(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
            datosConsulta: [],
        });
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const funcionarioActualizado = state.consultaSalidas;
            funcionarioActualizado[clave] = valor;
            return{
                consultaSalidas: funcionarioActualizado,
            };
        })
    }

    async manejoEnvioNumeroFuncionario(e){
        e.preventDefault();
        if(this.state.consultaSalidas.numeroFuncionario === ''){
            this.setState({
                errores: 'Debe ingresar el número de funcionario!',
            })
        }else{

            const cargaUtil = JSON.stringify([this.state.consultaSalidas]);
            const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_salidasEH.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();

            this.setState({
                errores: exito[0],
                notificaciones: null,
                consulta: false,
            });

            if(exito[0] === 'ok'){
                this.setState({
                    errores: null,
                    notificaciones: null,
                    consulta: true,
                    datosConsulta: exito[1],
                })
            }
        }
    }

    manejarBorrar(dato){
        this.setState({
            modalBorrar: true,
            marBorrar: dato,
            notificaciones: null,
            errores: null,
        });
    }

    manejarEdicion(dato){
        this.setState({
            modalEditar: true,
            modalBorrar: false,
            marBorrar: dato,
            notificaciones: null,
            errores: null,
        });
    }

    manejarAtras(e){
        e.preventDefault();
        this.setState({
            modalBorrar: false,
            modalEditar: false,
            notificaciones: null,
            errores: null,

            consultaSalidas: {
                numeroFuncionario: '',
                fecha: '',
            },

            consulta: false,

            marBorrar: {
                idMovimiento: '',
                numeroFuncionario: '',
                nombreFuncionario: '',
                desde: '',
                entradaSEH: '',
                salidaSEH: '',
            },

            datosConsulta: [],
        })
    }

    async manejarEnvioBaja(e){
        e.preventDefault();
        const cargaUtil = JSON.stringify([this.state.marBorrar, sessionStorage.numeroFuncionario, sessionStorage.numeroFuncionarioAsociado]);

        const respuesta = await fetch(`${Constantes.RUTA_API}/borrar_SalidaEH.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        if(exito[0] === 'ok'){
            let contador = 0;
            const arr = this.state.datosConsulta;
            arr.map((name) => {
                if(this.state.marBorrar.idMovimiento === name.idMovimiento){
                    arr.splice(contador, 1);
                }else{
                    contador++;
                }
            });
            this.setState({
                notificaciones: 'Los datos fueron borrados correctamente',
                modalBorrar: false,
                modalEditar: false,
                datosConsulta: arr,
                errores: null,
            });
        }
    }

    cerrarModal(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
            modalBorrar: false,
            modalEditar: false,
        })
    }

    manejarCambioEditar(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const movEditarActualizado = state.marBorrar;

            movEditarActualizado[clave] = valor;
            return {
                marBorrar: movEditarActualizado,
            }
        })
    }

    async manejarEnvioModificar(e){
        e.preventDefault();
        const cargaUtil = JSON.stringify([this.state.marBorrar]);

        const respuesta = await fetch(`${Constantes.RUTA_API}/editar_salidaEH.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        this.setState({
            errores: exito[0],
            modalActualizar: false,
        });
        if(exito[0] === 'ok'){
            this.setState({
                notificaciones: 'Los datos fueron ingresados correctamente',
                modalEditar: false,
                errores: null,
            });
        }
    }
}

export default SalidaEntreHorario